<a
  class="challenge-wrap"
  [ngClass]="{
    'has-motivation-message': showMotivationMessage,
    'ended': challenge.status.state === challengeState.ended
  }"
  [routerLink]="challengeUrl"
  *ngIf="challenge">
  <div class="challenge">
    <kf-sc-social-challenge-label
      *ngIf="challenge.status.state !== challengeState.ended && showExtraneous"
      class="challenge-label"
      [challenge]="challenge"></kf-sc-social-challenge-label>
    <div class="challenge-image hidden-print" *ngIf="showImage">
      <img [src]="challenge.mediaObject.url + '?h=400'" [alt]="challenge.mediaObject.description ?? ''" />
    </div>
    <div class="challenge-info">
      <div class="challenge-details">
        <h2 class="title">
          {{ challenge.title }}
        </h2>
        <div class="tertiary-challenge-info" *ngIf="tertiaryChallengeInfo">
          <span *ngIf="tertiaryChallengeInfo.state">{{ tertiaryChallengeInfo.state }}</span>
          <span *ngIf="tertiaryChallengeInfo.separator">{{ tertiaryChallengeInfo.separator }}</span>
          <span *ngIf="tertiaryChallengeInfo.statusIcon">
            <svg-icon [src]="tertiaryChallengeInfo.statusIcon"></svg-icon>
          </span>
          <span *ngIf="tertiaryChallengeInfo.status">{{ tertiaryChallengeInfo.status }}</span>
        </div>
      </div>
      <kf-sc-social-challenge-progress
        class="challenge-progress-visual"
        *ngIf="challenge.status.state !== challengeState.upcoming && challenge.individual.status.enrolled"
        [groupGoal]="challenge.group.goal"
        [groupProgress]="challenge.group.status.progress?.count"
        [individualGoal]="challenge.individual.goal"
        [individualProgress]="challenge.individual.status.progress?.count"
        [individualDayComplete]="challenge.individual.status.completedToday"
        [individualCompleted]="challenge.individualGoalCompleted"></kf-sc-social-challenge-progress>
    </div>
  </div>
  <div class="motivation-message" *ngIf="showMotivationMessage">
    <svg-icon src="/assets/icons/mountain-summit-flag-no-border.svg"></svg-icon>
    <kui-rich-text class="message" [richText]="motivationMessage" [onBackground]="true"></kui-rich-text>
  </div>
</a>
